import React, { useMemo } from "react";

import { Executor } from "../../../../../../../services";
import { useTypedSelector } from "../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../LightTable";
import { Row } from "..";

const CompanyCellContent: React.FC<CompanyCellContent.Props> = ({ item }) => {
	const lang = useTypedSelector((state) => state.session.language);
	const content = useMemo(
		() => item.taxiService?.company?.name?.[lang] ?? "",
		[item.taxiService?.company?.name, lang],
	);

	return (
		<CellContentRoot
			alignItems="center"
			w="100%"
			h="100%"
			p="0"
			cursor="pointer"
		>
			<Row
				active={item.active}
				// onDoubleClick={() => onRowDoubleClick(rowData)}
			>
				{content}
			</Row>
		</CellContentRoot>
	);
};

declare namespace CompanyCellContent {
	interface Props {
		item: Executor.Model;
	}
}

export default React.memo(CompanyCellContent);
